module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter3"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "href": "#/004toc#ch3"
    }
  }, [_vm._v("Basic Cupcake Pops")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image7"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('img', {
    attrs: {
      "alt": "image 7",
      "src": "images/image-007.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Not only can you make cake balls and turn them into cake pops, but you can also mold them into other shapes using a small metal cookie cutter. For these cupcake pops, use a flower-shaped cookie cutter. Take them to the next level of cuteness by using more than one color of candy coating and adding sprinkles and candy for decoration.")]), _vm._v(" "), _c('h4', [_vm._v("Makes 48 cupcake pops")]), _vm._v(" "), _c('h4', [_vm._v("You’ll need")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("18.25-ounce box cake mix")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("9-by-13-inch cake pan")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Large mixing bowl")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("16-ounce container ready-made frosting")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Large metal spoon")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Wax paper")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 baking sheets")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Plastic wrap")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Flower-shaped cookie cutter (1 "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" inches wide by "), _c('sup', [_vm._v("3")]), _vm._v("/"), _c('sub', [_vm._v("4")]), _vm._v(" inch deep)")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("32 ounces (2 pounds) chocolate candy coating")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("2 deep, microwave-safe plastic bowls")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Dish towel")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("48 paper lollipop sticks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("16 ounces pink candy coating")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Toothpicks")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("M&M’s or similarly shaped candy")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Sprinkles")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }, [_vm._v("Styrofoam block (see "), _c('a', {
    attrs: {
      "href": "#/020chapter13"
    }
  }, [_vm._v("Equipment")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "hang"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bake the cake as directed on the box, using a 9-by-13-inch cake pan. Let cool completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once the cake is cooled, get organized and set aside plenty of time (a few hours) to crumble, roll, shape, dip, and decorate 4 dozen cupcake pops.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Crumble the cooled cake into a large bowl. See "), _c('a', {
    attrs: {
      "href": "#/014chapter7"
    }
  }, [_vm._v("“Crumbling Your Cake.”")]), _vm._v(" You should not see any large pieces of cake.")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_vm._v("After I discovered that candy coatings came in so many colors, I was eager to experiment. The cake pops are cute, but I wanted to make them even cuter. Turning them into cupcakes was the obvious next step for me. One day an idea came in the form of a cookie cutter I had lying around the kitchen, and I developed this little technique for shaped cakes that I call cupcake pops. The response was overwhelming, from an invitation to appear on The Martha Stewart Show to the many messages from the wonderfully sweet readers of Bakerella.com who shared their excitement of learning to make these treats.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("Add three-quarters of the container of frosting. (You will not need the remaining frosting.) Mix it into the crumbled cake, using the back of a large metal spoon, until thoroughly combined. If you use the entire container, the cake balls will be too moist.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The mixture should be moist enough to roll into 1 "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v("-inch balls and still hold a round shape. After rolling the cake balls by hand, place them on a wax paper–covered baking sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cover with plastic wrap and chill for several hours in the refrigerator, or place in the freezer for about 15 minutes. You want the balls to be firm but not frozen.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove the baking sheet from the refrigerator or freezer and begin shaping the cake balls into cupcakes. Take a chilled ball and roll it into a cylinder shape. Then slide it into the flower-shaped cookie cutter. The cake mixture should fill the entire cutter, with any excess forming a mounded cupcake top on one side. You can use your thumb to keep the shape flat on one side, allowing the rest to form a mound on the other. When you have the shape the way you like it, gently push the shaped cupcake out of the cutter from the bottom. If the mixture is still firm enough, you should also be able to gently pull it out by holding the top mounded side.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the cupcake-shaped cake ball, right-side up, back on the wax paper–covered baking sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Continue with the remaining cake balls.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once the balls are all shaped into cupcakes, return them to the freezer for 5 to 10 minutes to keep them firm.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the chocolate candy coating in a deep, microwave-safe plastic bowl. These bowls make it easier to dip the cupcake bottoms completely in candy coating while holding the bowl without burning your fingers. (I usually work with about 16 ounces of coating at a time.)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Melt the chocolate candy coating, following the instructions on the package. Microwave on medium power for 30 seconds at a time, stirring with a spoon in between. You can also use a double boiler. Either way, make sure you do not overheat the coating. See "), _c('a', {
    attrs: {
      "href": "#/016chapter9"
    }
  }, [_vm._v("“Candy Coating Basics,”")]), _vm._v(" for more on working with candy coating.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Now you’re ready to dip. Take a few cupcake-shaped balls at a time out of the refrigerator or freezer to work with. Transfer the rest to the refrigerator at this point, so they stay firm but do not freeze.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One at a time, take a cupcake-shaped cake ball and, holding it by the mounded top, dip the bottom into the melted chocolate candy coating—just to the point where the mounded shape starts. Remove it from the chocolate, turn it upside down, and swirl your hand in a circular motion. This will cause any excess chocolate coating to slide down. When the coating reaches the bottom of the mounded cupcake top, you can stop. Have a dish towel handy to wipe off your fingertips, as it is highly likely that you’ll get some coating on them. Don’t use water to rinse your hands, because getting water in the coating can make it unusable.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the half-coated cupcake shape on the second wax paper– covered baking sheet, chocolate-candy-coating-side up, mounded-side down. Immediately dip about "), _c('sup', [_vm._v("1")]), _vm._v("/"), _c('sub', [_vm._v("2")]), _vm._v(" inch of the tip of a lollipop stick into the melted candy coating, and insert the stick straight into the flat, chocolate-coated bottom of the cupcake while the chocolate is still wet. Push it no more than halfway through.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Continue with the rest of the cupcake-shaped cake balls.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Allow the chocolate to dry completely.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Melt the pink candy coating in the same way that you melted the chocolate. You will now decorate the tops. This all comes together quickly, resulting in a finished cupcake pop.")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image8"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('img', {
    attrs: {
      "alt": "image 8",
      "src": "images/image-008-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-008-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-008-3.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/image-008-4.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("Holding its lollipop stick, dip the top of a cupcake in the melted pink candy coating. It should completely cover the rest of the exposed cupcake and meet the edge of the chocolate coating.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Remove the cupcake pop from the coating and turn it right-side up. If the coating is too hot, it will start to drip down the sides. If this happens, let the coating sit for a few minutes to cool and start to thicken. Then when you dip the tops, the coating will stay in place.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While the coating is still wet, use a toothpick to touch up any areas the coating may not have covered. Then place 1 M&M (M-side down) on the top and add sprinkles for decoration (see "), _c('a', {
    attrs: {
      "href": "#/021chapter14"
    }
  }, [_vm._v("Sprinkles")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Place the cupcake pop in a prepared Styrofoam block to dry completely. Repeat with the remaining cupcake pops.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Store the cupcake pops in an airtight container on the counter or in the refrigerator for several days. You can also cover them in small treat bags, tied with a ribbon, and leave them in the Styrofoam block on the counter.")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image9"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 9",
      "src": "images/image-009.jpg"
    }
  })])]), _vm._v(" "), _c('h2', {
    staticClass: "left"
  }, [_vm._v("Tips")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Make the cake the day before and let it cool overnight. Then you can do the crumbling, rolling, shaping, dipping, and decorating on the second day.")]), _vm._v(" "), _c('li', [_vm._v("You can also leave uncoated cake balls, covered in plastic wrap, in the refrigerator overnight if you want to do the dipping on the following day.")]), _vm._v(" "), _c('li', [_vm._v("You can make these without lollipop sticks. They’re just as cute.")]), _vm._v(" "), _c('li', [_vm._v("Don’t get any water in the candy coating. Keep your hands completely dry. Water will mess up the coating and ruin all your hard work.")]), _vm._v(" "), _c('li', [_vm._v("Poke holes in the Styrofoam block before you start dipping, using a lollipop stick. Leave enough space between the holes so the cakes won’t touch.")]), _vm._v(" "), _c('li', [_vm._v("Experiment with different candy coating color combinations.")]), _vm._v(" "), _c('li', [_vm._v("You can also use this technique with other small cookie cutters, such as hearts or butterflies (see "), _c('a', {
    attrs: {
      "href": "#/024chapter16"
    }
  }, [_vm._v("Sweet Hearts")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/025chapter17"
    }
  }, [_vm._v("Spring Fling")]), _vm._v(").")]), _vm._v(" "), _c('li', [_vm._v("You can place sprinkles in a small dish and pinch a few with your fingers to sprinkle over a larger bowl to reuse any that fall.")]), _vm._v(" "), _c('li', [_vm._v("To see a video demonstration of creating cupcake pops, go to www.marthastewart.com/recipe/cupcake-pops.")])]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image10"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('img', {
    attrs: {
      "alt": "image 10",
      "src": "images/image-010.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a67f171e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009-chapter3.vue
// module id = 81
// module chunks = 0